/**
 * @flow
 */
import Box from '@mui/material/Box';
import { SvgIcon, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import Confirm from 'assets/icons/question-confirm.svg';
import FileUpload from 'assets/icons/question-file-upload.svg';
import ImageUpload from 'assets/icons/question-image-upload.svg';
import MultipleChoice from 'assets/icons/question-multiple-choice.svg';
import SingleChoice from 'assets/icons/question-single-choice.svg';
import Text from 'assets/icons/question-text.svg';
import React from 'react';

const options = { SingleChoice, MultipleChoice, ImageUpload, FileUpload, Confirm, Text };

const IconWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'questionType',
})(({ theme, questionType }) => ({
  borderRadius: '5px',
  backgroundColor: theme.palette.questions[questionType],
  color: alpha(theme.palette.white, 0.9),
  display: 'flex',
  alignItems: 'center',
}));

const QuestionTypeIcon = ({
  type,
  text = '',
  className,
  sx,
}: {
  type: string,
  text?: string,
  className?: string,
  sx?: Object,
}) => {
  const Icon = options[type];
  return (
    <IconWrapper questionType={type} className={className} sx={sx}>
      <SvgIcon sx={{ mr: text ? 1 : 0 }}>
        <Icon />
      </SvgIcon>
      {text ? (
        <Typography sx={{ mr: '10px', color: 'white', minWidth: '20px', textAlign: 'right' }}>
          {text}
        </Typography>
      ) : null}
    </IconWrapper>
  );
};

export default QuestionTypeIcon;
